import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhonelinkIcon(props: IconProps) {
    return <Icon {...props} iconKey={"phonelink"}/>
}
